/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Button, IconCode, IconPlus, Text } from '@vtex/admin-ui'
import type { AdditionalInformation as AdditionalInformationType } from 'typings'
import { useFormStateContext } from '../../../../providers'
import { Tag, TagsList } from '../../../Tag'

import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { useDrawerState } from '../../../Drawer'
import { Full } from '../../../Full'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleIcon,
  RuleStack,
} from '../../RuleStack'
import { Editor } from './Editor'
import styles from './additionalInformation.css'
import { messages } from './messages'

type Props = {
  name: string
}

export function AdditionalInformation(props: Props) {
  const { name } = props
  const { formatMessage: i18n } = useIntl()
  const { form } = useFormStateContext()
  const editorState = useDrawerState()

  const entries: AdditionalInformationType[] = useWatch({ form, name })

  const onEdit = () => editorState.show()

  const onRemove = () => form.setValue(name, [])

  return (
    <Full>
      <Text variant="action1" className={styles.title}>
        {i18n(messages.title)}
      </Text>

      {entries.length ? (
        <RuleStack>
          <Rule onClick={onEdit}>
            <RuleIcon>
              <IconCode />
            </RuleIcon>

            <RuleContent>
              <TagsList>
                {entries.map(({ name, value }, index) => (
                  <Tag key={index} className={styles.tag}>
                    {name}={value}
                  </Tag>
                ))}
              </TagsList>
            </RuleContent>

            <RuleActions>
              <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
            </RuleActions>
          </Rule>
        </RuleStack>
      ) : (
        <Button
          variant="secondary"
          icon={<IconPlus />}
          onClick={editorState.show}
        >
          {i18n(messages.create)}
        </Button>
      )}

      <Editor
        state={editorState}
        initialValues={entries}
        onSave={(values) => form.setValue(name, values)}
      />
    </Full>
  )
}
